var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewAllReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 21.375H31.5C31.7984 21.375 32.0845 21.4935 32.2955 21.7045C32.5065 21.9155 32.625 22.2016 32.625 22.5V31.5C32.625 31.7984 32.5065 32.0845 32.2955 32.2955C32.0845 32.5065 31.7984 32.625 31.5 32.625H4.5C4.20163 32.625 3.91548 32.5065 3.7045 32.2955C3.49353 32.0845 3.375 31.7984 3.375 31.5V22.5C3.375 22.2016 3.49353 21.9155 3.7045 21.7045C3.91548 21.4935 4.20163 21.375 4.5 21.375H11.25",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.375V20.25",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 14.625L18 21.375L24.75 14.625",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 28.125C26.4963 28.125 27 27.6213 27 27C27 26.3787 26.4963 25.875 25.875 25.875C25.2537 25.875 24.75 26.3787 24.75 27C24.75 27.6213 25.2537 28.125 25.875 28.125Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAllReports);
export default __webpack_public_path__ + "static/media/view-all-reports.86e45800274386567f7530bcdd4d599a.svg";
export { ForwardRef as ReactComponent };